module.exports = __webpack_public_path__ + "static/media/bj.148de921.svg";